import { type TaxReturnFormLoadingState } from '@dec/shared';
import type React from 'react';

import { HandlerCellChanged, HandlerFormulaFailed } from '../../Form/HandlerCellChanged';
import { HandlerLostConnection } from '../../Form/HandlerLostConnection';
import { Initializer } from '../../Form/Initializer';

interface Props {
  readOnly: boolean;
  setLoading: React.Dispatch<React.SetStateAction<TaxReturnFormLoadingState>>;
  onCellChanged?: () => void;
}

export const FormRuntimeHandlers = ({ readOnly, setLoading, onCellChanged }: Props) => (
  <>
    <HandlerLostConnection setLoading={setLoading} />
    <HandlerCellChanged onChange={onCellChanged} />
    <HandlerFormulaFailed />
    <Initializer readOnly={readOnly} />
  </>
);
